import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home, ArrowLeft } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const COPY = {
  tr: {
    title: 'Sayfa bulunamadı',
    body: 'Aradığınız sayfa taşınmış veya hiç var olmamış olabilir.',
    home: 'Ana sayfaya dön',
    blog: 'Blogu incele',
  },
  en: {
    title: 'Page not found',
    body: 'The page you are looking for may have moved, or it never existed.',
    home: 'Back to home',
    blog: 'Browse the blog',
  },
  de: {
    title: 'Seite nicht gefunden',
    body: 'Die gesuchte Seite wurde möglicherweise verschoben oder hat nie existiert.',
    home: 'Zur Startseite',
    blog: 'Zum Blog',
  },
  es: {
    title: 'Página no encontrada',
    body: 'Es posible que la página que buscas se haya movido o que nunca haya existido.',
    home: 'Volver al inicio',
    blog: 'Ver el blog',
  },
  fr: {
    title: 'Page introuvable',
    body: "La page que vous cherchez a peut-être été déplacée, ou n'a jamais existé.",
    home: "Retour à l'accueil",
    blog: 'Voir le blog',
  },
};

/**
 * Catch-all route. nginx already returns a real 404 status for unknown paths
 * (see nginx.conf `error_page 404 /404.html`); this renders the body for both
 * that response and for client-side navigations to an unknown path.
 */
export const NotFound = () => {
  const { language } = useLanguage();
  const c = COPY[language] || COPY.en;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-cyan-50 to-white dark:from-gray-900 dark:to-gray-800 px-4 transition-colors duration-300">
      <Helmet>
        <title>{`404 - ${c.title} | FeedPanels`}</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="text-center max-w-md">
        <img
          src="/logo-256.webp"
          alt="FeedPanels"
          width="96"
          height="95"
          className="w-24 h-24 object-contain mx-auto mb-6"
        />
        <p className="text-6xl font-extrabold text-cyan-600 dark:text-cyan-400 mb-3">404</p>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-3">
          {c.title}
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">{c.body}</p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-cyan-500 to-blue-500 text-white font-semibold shadow-lg hover:shadow-xl transition-shadow"
          >
            <Home className="w-4 h-4" />
            {c.home}
          </Link>
          <a
            href="/blog"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl border-2 border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 font-semibold hover:border-cyan-300 dark:hover:border-cyan-600 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            {c.blog}
          </a>
        </div>
      </div>
    </div>
  );
};
